import { render, staticRenderFns } from "./releaselog.vue?vue&type=template&id=d668cfc8&"
import script from "./releaselog.vue?vue&type=script&lang=js&"
export * from "./releaselog.vue?vue&type=script&lang=js&"
import style0 from "./releaselog.vue?vue&type=style&index=0&id=d668cfc8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports